import { render, staticRenderFns } from "./SupportBadge.vue?vue&type=template&id=5a20557a&scoped=true&"
import script from "./SupportBadge.vue?vue&type=script&lang=js&"
export * from "./SupportBadge.vue?vue&type=script&lang=js&"
import style0 from "./SupportBadge.vue?vue&type=style&index=0&id=5a20557a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20557a",
  null
  
)

export default component.exports